import React from "react";
import { Phone, MapPin, Mail, MessageCircle, Sparkles } from "lucide-react";
import { brand } from "../mock";

export default function ContactCTA({ onEnroll }) {
  return (
    <section id="contact" className="section-light py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="relative rounded-3xl overflow-hidden border border-[#F59E0B]/30 p-8 md:p-14"
          style={{
            background:
              "radial-gradient(600px 400px at 10% 10%, rgba(251,191,36,0.35), transparent 60%), radial-gradient(600px 400px at 90% 90%, rgba(236,72,153,0.25), transparent 60%), linear-gradient(135deg, #FFF3D6 0%, #FFE8E1 100%)",
          }}
        >
          <div className="absolute inset-0 grid-pattern opacity-70 pointer-events-none" />
          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#F59E0B]/40 text-[#B45309] text-xs font-black tracking-wider uppercase shadow-sm">
                <Sparkles size={14} /> Limited Seats – This Batch
              </div>
              <h2 className="section-title mt-4 text-4xl md:text-5xl font-black brand-navy leading-[1]">
                Ready to <span className="gold-gradient">shape your future?</span>
              </h2>
              <p className="mt-4 text-[#0A1740]/75 max-w-lg">
                Talk to our counsellor and book a free demo class. No commitment.
                Just a conversation that could change everything.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <button onClick={onEnroll} className="btn-primary px-6 py-3.5 rounded-full text-sm md:text-base">
                  Book Free Demo
                </button>
                <a
                  href={brand.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-ghost px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm md:text-base"
                >
                  <MessageCircle size={18} /> WhatsApp Us
                </a>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              <Card icon={Phone} title="Call Us" value={brand.phone} href={brand.phoneDial} />
              <Card icon={Mail} title="Email" value={brand.email} href={`mailto:${brand.email}`} />
              <Card
                icon={MapPin}
                title="Visit"
                value={brand.address}
                href="https://maps.google.com/?q=Vizianagaram"
                target="_blank"
              />
              <Card icon={MessageCircle} title="WhatsApp" value="Chat instantly" href={brand.whatsapp} target="_blank" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Card({ icon: Icon, title, value, href, target }) {
  return (
    <a
      href={href}
      target={target}
      rel={target ? "noreferrer" : undefined}
      className="rounded-2xl border border-[#0A1740]/10 bg-white/85 hover:bg-white transition-colors p-5 flex items-start gap-4 shadow-sm hover:shadow-md"
    >
      <div className="w-11 h-11 shrink-0 rounded-xl bg-[#FEF3C7] border border-[#F59E0B]/40 flex items-center justify-center text-[#B45309]">
        <Icon size={18} />
      </div>
      <div className="min-w-0">
        <div className="text-[11px] uppercase tracking-widest text-[#0A1740]/50 font-bold">{title}</div>
        <div className="brand-navy font-bold text-sm truncate">{value}</div>
      </div>
    </a>
  );
}
